export default __webpack_public_path__ + "static/media/08.9a6b711f.png";